import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import SupRestaurant from './SupervisorRestaurant';
import Order from './Order';    
import Payment from './Payment';  
import Settings from './Settings';  
import UserManagement from './UserManagementAdmin'; 
import Pickup from './Pickup'
import Inventory from './Inventory';

import './css/Home.css';

const SUPERVISOR_TABS = ['restaurants', 'orders', 'pickup', 'payment', 'inventory', 'user-management', 'settings'];

function getSupervisorTabFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const tab = params.get('tab');
  return SUPERVISOR_TABS.includes(tab) ? tab : null;
}

const Supervisor = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const fromUrl = getSupervisorTabFromUrl();
    return fromUrl || 'restaurants';
  });

  useEffect(() => {
    const fromUrl = searchParams.get('tab');
    if (SUPERVISOR_TABS.includes(fromUrl)) setActiveTab(fromUrl);
  }, [searchParams]);

  const handleTabClick = (tab) => {
    if (!SUPERVISOR_TABS.includes(tab)) return;
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  // Keep instances of the components
  const renderTabContent = () => {
    switch (activeTab) {
      case 'restaurants':
        return <SupRestaurant />;
      case 'orders':
        return <Order />;
      case 'pickup':
        return <Pickup />;
      case 'payment':
        return <Payment />;
      case 'inventory':
        return <Inventory />;
        // eslint-disable-next-line
      case 'user-management':
        return <UserManagement />;
        // eslint-disable-next-line
      case 'settings':
        return <Settings />;
      // eslint-disable-next-line
      default:
        return null;
    }
  };

  return (
    <div className="home-container">
      <div className="tab-container">
        <h2 
          className={`tab-heading ${activeTab === 'restaurants' ? 'active' : ''}`}
          onClick={() => handleTabClick('restaurants')}
        >
          Menu
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'orders' ? 'active' : ''}`}
          onClick={() => handleTabClick('orders')}
        >
          Orders
        </h2>
        <h2
          className={`tab-heading ${activeTab === 'pickup' ? 'active' : ''}`}
          onClick={() => handleTabClick('pickup')}
        >
          Pick Up
        </h2>
          
        <h2 
          className={`tab-heading ${activeTab === 'payment' ? 'active' : ''}`}
          onClick={() => handleTabClick('payment')}
        >
          Payment
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'inventory' ? 'active' : ''}`}
          onClick={() => handleTabClick('inventory')}
        >
          Inventory
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'user-management' ? 'active' : ''}`}
          onClick={() => handleTabClick('user-management')}
        >
          User Management
        </h2>
        <h2 
          className={`tab-heading ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => handleTabClick('settings')}
        >
          Settings
        </h2>
      </div>
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Supervisor;
